export const ANIMATED_HEIGHT_DEFAULT_OPTIONS = {
    content: null,
    duration: 400,
    height: 'auto',
    maxHeight: null,
    minHeight: null,
};
